import { useEffect, useState } from 'react';
import { fetchProfileData, ProfileData } from 'shared/api/fetchProfileData';
import { UCHI_DOMAIN } from '../../../../shared/constants';

export const useFetchTestData = () => {
  const [AZLabel, setAZLabel] = useState<string>('');
  const [courseParallel, setCourseParallel] = useState<'1-2' | '3-4'>('1-2');

  useEffect(() => {
    (async () => {
      try {
        const user = await fetchProfileData();
        const res = await fetch(
          `${UCHI_DOMAIN}/api/v1/az_tests?labels[]=vebinar_3_land&entities[]=User&num_id=student-${
            (user as ProfileData)?.id
          }`,
        );
        const testData = await res.json();
        setAZLabel(testData.vebinar_3_land);
        const parallel = (user as ProfileData)?.class_book_parallel;
        if (parallel === 1 || parallel === 2) {
          setCourseParallel('1-2');
        } else {
          setCourseParallel('3-4');
        }
      } catch (error) {
        console.error('error this AZ test label');
      }
    })();
  }, []);

  const isCourses = AZLabel === 'target';
  const isSubscription = AZLabel === 'control';
  const isSubjects = AZLabel === 'fake_target';
  const isLongControl = AZLabel === 'long_control';

  return { isCourses, isSubjects, isSubscription, courseParallel, isLongControl };
};
